import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'credit-notes';

const downloadCreditNotePdfById = (id, type) => {
  const url = `${env.api.url}/${USE_CASE_URL}/${id}/download/pdf?type=${type}`;

  window.location = url;
};

export default downloadCreditNotePdfById;
